import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuList,
  MenuItem as MuiMenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import { Menu } from "src/pi/application/Menu";
import DynamicIcon from "../../DynamicIcon";
import MenuItemComponent from "./MenuItemComponent";

interface IProps {
  menu: Menu;
  showIcon?: boolean;
}

const MenuComponent: React.FC<IProps> = observer((props) => {
  const { menu, showIcon } = props;

  if (!menu.isEnabled) {
    return (
      <MuiMenuItem key={menu.name} disabled={true}>
        <ListItemText primary={menu.label} />
      </MuiMenuItem>
    );
  }

  const theme = useTheme();
  const hasIcon = menu.items?.filter((x) => x.icon != null).length > 0;

  const style =
    menu.open && menu.collapsible
      ? { backgroundColor: theme.palette.action.selected }
      : ({} as React.CSSProperties);

  return (
    <div key={menu.name}>
      <MuiMenuItem
        key={menu.name}
        onClick={() => (menu.open = !menu.open)}
        style={style}
      >
        {showIcon && (
          <ListItemIcon>
            <DynamicIcon icon={menu.data.icon} color="inherit" />
          </ListItemIcon>
        )}
        <ListItemText primary={menu.label} />
        {menu.open ? (
          menu.collapsible ? (
            <ExpandLess />
          ) : undefined
        ) : (
          <ExpandMore />
        )}
      </MuiMenuItem>

      <Collapse
        in={menu.open}
        timeout="auto"
        unmountOnExit={true}
        style={{
          ...style,
          paddingLeft: "16px",
        }}
      >
        <MenuList>
          {menu.items.map((item, i) => (
            <MenuItemComponent
              key={`${i}-${item.label}`}
              item={item}
              showIcon={hasIcon}
            />
          ))}
        </MenuList>
      </Collapse>
      {menu.open && <Divider />}
    </div>
  );
});

export default MenuComponent;
